import React, { Component } from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab, faFacebook, faYoutube, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { Link } from 'react-router-dom';
library.add(fab, faFacebook, faYoutube, faInstagram, faTwitter)

class Footer extends Component{
    render(){
        return(
       <div>
       <section class="link">
      <div class="logos">
        <a target="_blank" rel="noopener noreferrer" href="https://facebook.com/codeflarelimited"><FontAwesomeIcon className="icon" icon={["fab", "facebook"]} /></a>
        <a target= "_blank" rel="noopener noreferrer" href="https://www.instagram.com/codeflare_limited/"><FontAwesomeIcon className="icon" icon={["fab", "instagram"]} /></a>
        {/* <a target="_blank" rel="noopener noreferrer" href="#"><FontAwesomeIcon className="icon" icon={["fab", "twitter"]} /></a> */}
        <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCuBLtiYqsajHdqw0uyt7Ofw?sub_confirmation=1"><FontAwesomeIcon className="icon" icon={["fab", "youtube"]} /></a>
      </div>
      <div class="sub-links">
        <ul>
          <li><a target="_blank" rel="noopener noreferrer" href="https://codeflarelimited.com">Home</a></li>
          <li><Link to="/catalogue/about" >About</Link></li>
          <li><Link to="/catalogue/develop">Build app</Link></li>
          <li><a target="_blank" rel="noopener noreferrer" href="https://codeflarelimited.com/computer-programming-tutorials-abuja.php">Tutorials</a></li>
          <li><a target="_blank" rel="noopener noreferrer" href="https://codeflarelimited.com/resources">Resources</a></li>
          <li><Link to="/catalogue/gallery">Gallery</Link></li>
          <li><a target="_blank" rel="noopener noreferrer" href="https://codeflarelimited.com/careers.php">Jobs</a></li>
          <li><Link to="/catalogue/frontend">Frontend path </Link></li>
          <li><Link to="/catalogue/backend">Backend path </Link></li>
          <li><Link to="/catalogue/data-science">Data science </Link></li>
          <li><Link to="/catalogue/react-training">React path </Link></li>
          <li><Link to="/catalogue/fullstack-js">Full-stack JS </Link></li>
          <li><Link to="/catalogue/fullstack-web-development">Full-stack web </Link></li>
          <li><Link to="/catalogue/java-training">Java path </Link></li>
          <li><Link to="/catalogue/android-development-training">Android path </Link></li>
          <li><Link to="/catalogue/cross-platform-app-development-training">React Native path </Link></li>
          <li><Link to="/catalogue/ui-ux-design">UI/UX path </Link></li>
          <li><Link to="/catalogue/photoshop">Photoshop path </Link></li>
          <li><Link to="/catalogue/ethical-hacking">Ethical hacking </Link></li>
          <li><Link to="/catalogue/contact" >Contact Us</Link></li>
        </ul>
      </div>
      <hr />
    </section>
    <footer>
      <p>&copy;{moment(this.props.dateToFormat).format('YYYY')} Codeflare Limited | All rights reserved.</p>  
    </footer>
            </div>
        )
    }
}

export default Footer;
